import ApiService from '../apiservice'

export default class ObjetoAcaoService extends ApiService {

  constructor() {
    super('/objetos')
  }

  listarObjetos(empresa) {
    return this.get(`?empresa=${empresa}`);
  }

  listarSubObjetos(codigo) {
    return this.get(`/subObjetos/${codigo}`);
  }

  listarObjetosForaProcesso(filtro) {
    return this.get(`/foraProcesso?empresa=${filtro.empresa}&processo=${filtro.processo}`);
  }

  listarSubObjetosForaProcesso(filtro) {
    return this.get(`/subObjetosForaProcesso?processo=${filtro.processo}&objetoPai=${filtro.objetoPai}`);
  }

  cadastrarObjeto(objeto) {
    return this.post('/',objeto);
  }

  consultarObjeto(codigo) {
    return this.get(`/${codigo}`);
  }

  alterarObjeto(objeto) {
    return this.put(`/${objeto.codigo}`, objeto);
  }

  excluirObjeto(codigo) {
    return this.delete(`/${codigo}`);
  }

  consultarObjetosPorCodigos(codigos) {
    return this.get(`/objetosPorCodigos?codigos=${codigos}`);
  }

  consultaRelatorio(empresa) {
    return this.get(`/consultaRelatorio/${empresa}`);
  }
}